
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"92.433","height":"92.425"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('path',{attrs:{"d":"M61.605 8.39l-1.57.91-3.47 2-26.5 15.3-6.92 3.99-18.15 10.48a10 10 0 000 17.32l1.58.91 3.46 2 26.5 15.3 6.93 4 18.14 10.47a10 10 0 0015-8.66V17.05a10.007 10.007 0 00-15-8.66z","data-name":"Pfad 14216","fill":"#f5f5f5"}}),_c('path',{attrs:{"d":"M90.805 62.6l-14.2-24.59V46l10.74 18.6a8 8 0 01-6.93 12h-65.36a8 8 0 01-6.93-12l1.91-3.3 20.03-34.7L40.805 8a8 8 0 0113.86 0l1.9 3.3 3.46-2-1.9-3.3a12 12 0 00-20.78 0l-14.2 24.59L6.575 59.3l-1.91 3.3a12 12 0 0010.39 18h65.36a12 12 0 0010.39-18z","data-name":"Pfad 14217","opacity":".15","fill":"#1b5be9"}}),_c('g',[_c('path',{attrs:{"d":"M26 28h40v40H26z","fill":"none"}}),_c('path',{staticClass:"cls-4",attrs:{"d":"M46.833 49.602A10.846 10.846 0 0036 60.435a.786.786 0 00.786.786H56.88a.786.786 0 00.786-.786 10.846 10.846 0 00-10.833-10.833zm0 1.573a9.268 9.268 0 019.221 8.474H37.612a9.269 9.269 0 019.221-8.474z","data-name":"Pfad 14188"}}),_c('path',{staticClass:"cls-4",attrs:{"d":"M46.834 48.752a6.211 6.211 0 10-6.211-6.211 6.217 6.217 0 006.211 6.211zm0-10.849a4.638 4.638 0 11-4.638 4.638 4.643 4.643 0 014.638-4.635z","data-name":"Pfad 14189"}})])])
          )
        }
      }
    